import axios from 'axios';
import { INVITETEMPLATES_SET_SINGLE, INVITETEMPLATES_SET_LOADING } from "../types";
import {ENVIRONMENT_URL} from "constants/environment";

export const fetchSingleInviteTemplateAction = (bookId) => async (dispatch) => {
    dispatch({ type: INVITETEMPLATES_SET_LOADING, loading: true });

    try {
        const response = await axios.get(`${ENVIRONMENT_URL}/invites/invitation-template/${bookId}`);
        dispatch({
            type: INVITETEMPLATES_SET_SINGLE,
            inviteTemplate: response.data,
        });
    } catch (error) {
        console.error("Error fetching the invitation template:", error);
    } finally {
        dispatch({ type: INVITETEMPLATES_SET_LOADING, loading: false });
    }
};